import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { Form, Icon, Popup } from 'semantic-ui-react'
import { Modal } from 'dyl-components'
import "../index.scss"


const IconLabelWithInfo = ({ label, infoText, infoIconPosition = 'right', infoMessagePosition = 'left center', isModal = false, onClick = () => { } }) => {
    const infoIconStyle = infoIconPosition === null ? { marginLeft: '5px' } : { float: infoIconPosition };
    return (
        <React.Fragment style={{ display: 'flex', alignItems: 'center' }}>
            <label style={{ display: 'inline-block', fontWeight: 'bold' }}>{label}</label>
            {isModal ? <Icon
                className="fas fa-circle-info"
                color="primary"
                onClick={onClick}
                style={infoIconStyle}
            /> : (
                <Popup
                    trigger={
                        <Icon
                            className="fas fa-circle-info"
                            color="primary"
                            style={infoIconStyle}
                        />
                    }
                    position={infoMessagePosition}
                    content={infoText}
                    inverted
                    hoverable
                />
            )}
        </React.Fragment>
    )
}
const OptionalFeatureModal = ({ open, onClose }) => {
    return (
        <Modal open={open} onClose={() => { onClose(); }} size="small">
            <Modal.Header>Required & Optional Feature Selection</Modal.Header>
            <Modal.Content scrolling>
                <strong>Affiliate Marketing:</strong> Check this box if your campaign involves promoting third-party products or service.
                <br />
                <br />
                <strong>Direct Lending:</strong> Select this if your campaign pertains to offering or facilitating loans directly.
                <br />
                <br />
                <strong>Embedded Link:</strong> Check this box if your messages include links to external websites or resources.
                <br />
                <br />
                <strong>Embedded Phone:</strong> Select this if your messages contain phone numbers for direct contact.
                <br />
                <br />
                <strong>Number Pool:</strong> Indicate whether your campaign uses a pool of numbers instead of a single number.
                <br />
                <br />
                <strong>Age Gated:</strong> Check this if your campaign targets content restricted to certain age groups (e.g. 18+).
            </Modal.Content>
        </Modal>
    );
}

export default function AddCampaignRegistrationForm({ type, campaign }) {
    const { control, watch } = useFormContext()
    const [openOptionalFeatureModal, setOpenOptionalFeatureModal] = React.useState(false)

    const getStatusClass = (status) => {
        switch (status) {
            case 'PENDING':
                return '--pending';
            case 'ACTIVE':
                return '--active';
            case 'REJECTED':
                return '--rejected';
            default:
                return 'BrandRegistrationForm__Status';
        }
    }

    return (
        <Form>
            <Form.Group widths='equal'>
                <Controller
                    name="campaign_name"
                    control={control}
                    render={({ field: { name, value, onChange }, fieldState: { error } }) => (
                        <Form.Field>
                            <Form.Input
                                name={name}
                                value={value}
                                onChange={onChange}
                                label="Campaign Name"
                                placeholder="Enter Campaign Name"
                                error={error?.message}
                                required
                            />
                        </Form.Field>
                    )}
                />
            </Form.Group>
            <Form.Group widths='equal'>
                <Controller
                    name="main_usecase"
                    control={control}
                    render={({ field: { name, value, onChange }, fieldState: { error } }) => (
                        <Form.Field>
                            <Form.Select
                                name={name}
                                value={value}
                                onChange={(_, { name, value }) => {
                                    onChange({ target: { name, value } })
                                }}
                                label="Main Use Case"
                                placeholder="Select Main Use Case"
                                error={error?.message}
                                required
                                selectOnBlur={type === "low_volume" ?false : true}
                                options={type === "high_volume" ? [
                                    { key: 'account_notification', value: 'ACCOUNT_NOTIFICATION', text: 'Account Notification' },
                                    { key: 'customer_care', value: 'CUSTOMER_CARE', text: 'Customer Care' },
                                    { key: 'fraud_alert_message', value: 'FRAUD_ALERT', text: 'Fraud Alert Messaging' },
                                    { key: 'higher_education', value: 'HIGHER_EDUCATION', text: 'Higher Education' },
                                    { key: 'k_12_education', value: 'K_12_EDUCATION', text: 'K-12 Education' },
                                    { key: 'marketing', value: 'MARKETING', text: 'Marketing' },
                                    { key: 'mixed', value: 'MIXED', text: 'High Volume Mixed' }
                                ] : [
                                    { key: "low_volume_mixed", value: "LOW_VOLUME", text: "Low Volume Mixed" }
                                ]}
                            />
                        </Form.Field>
                    )}
                />
                <Controller
                    name="other_usecase"
                    control={control}
                    render={({ field: { name, value, onChange }, fieldState: { error } }) => (
                        <Form.Field>
                            <Form.Select
                                name={name}
                                value={value}
                                onChange={(_, { name, value }) => {
                                    onChange({ target: { name, value } })
                                }}
                                label={
                                    <IconLabelWithInfo
                                        infoText={"You can choose more than one Use Case within a single campaign."}
                                        label='Other Usecase'
                                    />
                                }
                                placeholder="Select Other Usecase"
                                error={error?.message}
                                disabled={type === "high_volume" && watch("main_usecase") !== "MIXED"}
                                required
                                options={[
                                    { key: "account_notification", value: "ACCOUNT_NOTIFICATION", text: "Account Notification" },
                                    { key: 'customer_care', value: 'CUSTOMER_CARE', text: 'Customer Care' },
                                    { key: 'fraud_alert_message', value: 'FRAUD_ALERT', text: 'Fraud Alert Messaging' },
                                    { key: 'delivery_notification', value: 'DELIVERY_NOTIFICATION', text: 'Delivery Notification' },
                                    { key: "marketing", value: "MARKETING", text: "Marketing" },
                                ]}
                                multiple
                            />
                        </Form.Field>
                    )}
                />
            </Form.Group>
            <Form.Group widths='equal'>

                <Controller
                    name="description"
                    control={control}
                    render={({ field: { name, value, onChange }, fieldState: { error } }) => (
                        <Form.Field>
                            <Form.TextArea
                                name={name}
                                value={value}
                                onChange={onChange}
                                label={
                                    <IconLabelWithInfo
                                        infoText={"Clearly define your business, the purpose of your SMS usage, and ensure alignment with approved use cases."}
                                        label='Description'
                                    />
                                }
                                placeholder="Enter Description"
                                error={error?.message}
                                required
                            />
                        </Form.Field>
                    )}
                />
            </Form.Group>
            <Form.Group widths='equal'>

                <Controller
                    name="website"
                    control={control}
                    render={({ field: { name, value, onChange }, fieldState: { error } }) => (
                        <Form.Field>
                            <Form.Input
                                name={name}
                                value={value}
                                onChange={onChange}
                                label={
                                    <IconLabelWithInfo
                                        infoText={"Provide the URL of your brand's official website or social media profile."}
                                        label='Website URL'
                                    />
                                }
                                placeholder="Type Website URL"
                                error={error?.message}
                                required
                            />
                        </Form.Field>
                    )}
                />
                <Controller
                    name="terms_and_conditions_url"
                    control={control}
                    render={({ field: { name, value, onChange }, fieldState: { error } }) => (
                        <Form.Field>
                            <Form.Input
                                name={name}
                                value={value}
                                onChange={onChange}
                                label={
                                    <IconLabelWithInfo
                                        infoText={"Provide the URL to your Terms and Conditions page."}
                                        label='Terms and Conditions URL'
                                    />
                                }
                                placeholder="Type Terms and Conditions URL"
                                error={error?.message}
                                required
                            />
                        </Form.Field>
                    )}
                />
            </Form.Group>
            <Form.Group widths='equal'>

                <Controller
                    name="privacy_policy_url"
                    control={control}
                    render={({ field: { name, value, onChange }, fieldState: { error } }) => (
                        <Form.Field>
                            <Form.Input
                                name={name}
                                value={value}
                                onChange={onChange}
                                label={
                                    <IconLabelWithInfo
                                        infoText={"Add your Privacy Policy URL to stay compliant."}
                                        label='Privacy Policy URL'
                                    />
                                }
                                placeholder="Type Privacy Policy URL"
                                error={error?.message}
                                required
                            />
                        </Form.Field>
                    )}
                />
            </Form.Group>
            <Form.Field label={
                <IconLabelWithInfo
                    infoText={"Provide sample messages that represent the content of being sent as part of this campaign. Ensure they align with your selected use case(s). If you have multiple use cases, input one sample message per usecase."}
                    label='Sample Message'
                    infoIconPosition={null}
                    infoMessagePosition='right center'
                />
            } required />
            <Controller
                name="sample_message_1"
                control={control}
                render={({ field: { name, value, onChange }, fieldState: { error } }) => (
                    <Form.Field>
                        <Form.Input
                            name={name}
                            value={value}
                            onChange={onChange}
                            label="Sample Message 1"
                            placeholder="Type Sample Message 1"
                            error={error?.message}
                            required
                        />
                        <span style={{ float: 'right' }}>Character Count: {value?.length || 0}/1024</span>
                    </Form.Field>
                )}
            />
            <Controller
                name="sample_message_2"
                control={control}
                render={({ field: { name, value, onChange }, fieldState: { error } }) => (
                    <Form.Field>
                        <Form.Input
                            name={name}
                            value={value}
                            onChange={onChange}
                            label="Sample Message 2"
                            placeholder="Type Sample Message 2"
                            error={error?.message}
                            required
                        />
                        <span style={{ float: 'right' }}>Character Count: {value?.length || 0}/1024</span>
                    </Form.Field>
                )}
            />
            <Controller
                name="sample_message_3"
                control={control}
                render={({ field: { name, value, onChange }, fieldState: { error } }) => (
                    <Form.Field>
                        <Form.Input
                            name={name}
                            value={value}
                            onChange={onChange}
                            label="Sample Message 3"
                            placeholder="Type Sample Message 3"
                            error={error?.message}
                            required
                        />
                        <span style={{ float: 'right' }}>Character Count: {value?.length || 0}/1024</span>
                    </Form.Field>
                )}
            />
            <Controller
                name="sample_message_4"
                control={control}
                render={({ field: { name, value, onChange }, fieldState: { error } }) => (
                    <Form.Field>
                        <Form.Input
                            name={name}
                            value={value}
                            onChange={onChange}
                            label="Sample Message 4"
                            placeholder="Type Sample Message 4"
                            error={error?.message}
                            required
                        />
                        <span style={{ float: 'right' }}>Character Count: {value?.length || 0}/1024</span>
                    </Form.Field>
                )}
            />
            <Controller
                name="sample_message_5"
                control={control}
                render={({ field: { name, value, onChange }, fieldState: { error } }) => (
                    <Form.Field>
                        <Form.Input
                            name={name}
                            value={value}
                            onChange={onChange}
                            label="Sample Message 5"
                            placeholder="Type Sample Message 5"
                            error={error?.message}
                            required
                        />
                        <span style={{ float: 'right' }}>Character Count: {value?.length || 0}/1024</span>
                    </Form.Field>
                )}
            />
            <Controller
                name='message_flow'
                control={control}
                render={({ field: { name, value, onChange }, fieldState: { error } }) => (
                    <Form.Field>
                        <Form.TextArea
                            name={name}
                            value={value}
                            onChange={onChange}
                            label={
                                <IconLabelWithInfo
                                    infoText={"Call to Action (CTA), provide clear instructions for consumers to opt in. CTA must explain the type of messages, frequency, charges, and opt-out instructions (e.g. 'Reply STOP to unsubscribe')."}
                                    label='Message Flow/Call to Action'
                                />
                            }
                            placeholder="Type Message Flow/Call to Action"
                            error={error?.message}
                            required
                            style={{ minHeight: 200 }}
                        />
                        <span style={{ float: 'right' }}>Character Count: {value?.length || 0}/4096</span>
                    </Form.Field>
                )}
            />
            <Form.Field label={<IconLabelWithInfo infoText={""} label="Required and Optional Features" infoIconPosition={null} isModal={true} onClick={() => setOpenOptionalFeatureModal(true)} />} />
            <Form.Group widths="equal">
                {[
                    { key: 'affiliate_marketing', label: 'Affiliate Marketing' },
                    { key: 'direct_lending', label: 'Direct Lending' },
                    { key: 'embedded_link', label: 'Embedded Link' },
                    { key: 'embedded_phone', label: 'Embedded Phone' },
                ].map(({ key, label }) => (
                    <Controller
                        key={key}
                        name="required_and_optional_features"
                        control={control}
                        render={({ field: { value = [], onChange }, fieldState: { error } }) => {
                            const isChecked = value.includes(key);
                            const handleChange = (_, data) => {
                                const newValue = data.checked
                                    ? [...value, key]
                                    : value.filter((item) => item !== key);
                                onChange(newValue);
                            };

                            return (
                                <Form.Field error={!!error}>
                                    <Form.Checkbox
                                        name={key}
                                        checked={isChecked}
                                        onChange={handleChange}
                                        label={label}
                                    />
                                </Form.Field>
                            );
                        }}
                    />
                ))}
            </Form.Group>
            <Form.Group widths="equal">
                {[
                    { key: 'number_pool', label: 'Number Pool' },
                    { key: 'age_gated', label: 'Age Gated' },
                    {
                        key: 'subscriber_opt_in',
                        label: 'Subscriber Opt In',
                        disabled: true,
                        required: true,
                    },
                    {
                        key: 'subscriber_help',
                        label: 'Subscriber Help',
                        disabled: true,
                        required: true,
                    },
                ].map(({ key, label, disabled, required }) => (
                    <Controller
                        key={key}
                        name="required_and_optional_features"
                        control={control}
                        render={({ field: { value = [], onChange }, fieldState: { error } }) => {
                            const isChecked = value.includes(key);

                            const handleChange = (_, data) => {
                                const newValue = data.checked
                                    ? [...value, key]
                                    : value.filter((item) => item !== key);
                                onChange(newValue);
                            };

                            return (
                                <Form.Field error={!!error}>
                                    <Form.Checkbox
                                        name={key}
                                        label={label}
                                        checked={isChecked}
                                        onChange={handleChange}
                                        disabled={disabled}
                                        required={required}
                                    />
                                </Form.Field>
                            );
                        }}
                    />
                ))}
            </Form.Group>
            <Form.Group widths='equal'>
                <Controller
                    name='approval_status'
                    control={control}
                    render={({ field: { name, value, onChange }, fieldState: { error } }) => (
                        <Form.Field>
                            <Form.Input
                                name={name}
                                value={value}
                                onChange={onChange}
                                label="Approval Status"
                                error={error?.message}
                                readOnly
                                className={`${value ? `CampaignRegistration__approvalStatus${getStatusClass(value)}` : ""}`} 
                            />
                            {campaign?.errors?.map((error, index) => {
                                return <span key={index} className='UserTableDropdown__ErrorMessage'>{error}</span>
                            })}
                        </Form.Field>

                    )}
                />
                <Form.Field>
                </Form.Field>
            </Form.Group>
            <OptionalFeatureModal open={openOptionalFeatureModal} onClose={() => { setOpenOptionalFeatureModal(false); }} />
        </Form>
    )
}
